// extracted by mini-css-extract-plugin
module.exports = {"description":"description_description__q6EQ_"};